<template>
  <div class="h-screen bg-cover bg-center background-image flex items-center justify-center">
    <v-card class="h-screen60 w-2/6 flex justify-center flex-col">
      <div class="flex justify-center">
        <img class="w-1/2" src="../assets/images/transmaes_logo_big.svg" alt="">
      </div>
      <login-form class="mt-12"/>
    </v-card>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import VCard from '../components/common/VCard';
  import LoginForm from '../components/forms/LoginForm';

  export default {
    name: 'TheLogin',
    components: {
      VCard,
      LoginForm,
    },
    created() {
      this.clearTokens();
    },
    methods: {
      ...mapActions('auth', {
        clearData: 'logout',
      }),
      clearTokens() {
        this.clearData();
      },
    },
  };

</script>

<style lang="scss" scoped>
  .background-image {
    background-image: url("../assets/images/background.jpg");
  }

</style>
